import { Component, OnInit, Input, SimpleChanges } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";

@Component({
	selector: "app-pdf-viewer",
	templateUrl: "./pdf-viewer.component.html",
	styleUrls: ["./pdf-viewer.component.css"],
})
export class PdfViewerComponent implements OnInit {
	@Input() pdfSrc: any;
	isLoading: boolean = false;
	pdfData: any;

	constructor(private domSanitizer: DomSanitizer) {}

	ngOnInit(): void {}

	ngOnChanges(changes: SimpleChanges) {
		// Obtenemos la informacion cada vez que cambie
		this.pdfData = changes.pdfSrc.currentValue;

		// validamos que sea correcta
		if (this.pdfSrc !== undefined) {
			this.generatePDF();
		}

	}

	// Metodo que genera el pdf
	async generatePDF() {
		if (this.pdfSrc instanceof Blob) {
			console.log('Es Blob');
			const blob = new Blob([this.pdfSrc], { type: "application/pdf" });
			this.pdfData = this.domSanitizer.bypassSecurityTrustResourceUrl(
				URL.createObjectURL(blob)
			);
			this.isLoading = true;
		} else {
			console.log("Es url");

			this.pdfData = this.domSanitizer.bypassSecurityTrustResourceUrl(
				this.pdfSrc
			);
			this.isLoading = true;

		}
	}
}
